export function isOmViewingTheirOwnProfile(
  isOm: boolean,
  loggedInUserId: string,
  displayedUserId: string
): boolean {
  return isOm && loggedInUserId === displayedUserId;
}
